import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
})
export class SpinnerComponent implements OnInit {
    @Input() onlySVG = false;
    @Input() SVGWithText = false;
    @Input() color = 'text-secondary';
    @Input() text = 'Cargando datos';
    constructor() {}

    ngOnInit() {}
}
